import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/group/list/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/group/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/park/group/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/group/submit/v2', params, options);

export const update = (params, options) => request.post('/api/park/group/submit/v2', params, options);

export const getParkGroupList = (params, options) =>
  request.post('/api/park/group/selections/v2', qs.stringify(params), options);
